import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "new-choice-label" }, "Libellé du choix", -1)
const _hoisted_4 = {
  key: 0,
  class: "form-text text-danger"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("legend", { class: "h5" }, "Options", -1)
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Choix unique "),
  /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, " (ex: \"Aucun\")")
], -1)

import { computed, ref } from 'vue';
import axios from '@/api';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import { useAlert } from '@/composables/alert';
import ActionDialog, { type ActionProps } from './ActionDialog.vue';
import ChoiceAddButton from './ChoiceAddButton.vue';
import FormCheck from './FormCheck.vue';
import type { Choice, ChoicePayload, Question } from '@/types/index.js';

interface ChoiceAddProps extends ActionProps {
    question: Question;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    question: null,
    campaignId: null
  },
  emits: ["created"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'created', choice: Choice): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    question: Question;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





const alert = useAlert();

const newChoice = ref<ChoicePayload>({
    name: '',
    isNone: false,
});

const isOpen = ref(false);

const isDisabled = computed<boolean>(() => {
    return '' === newChoice.value.name.trim();
});

const isDuplicate = computed<boolean>(() => {
    return props.question.choices.some((c) => c.name.trim() === newChoice.value.name.trim());
});

function reset(): void {
    newChoice.value.name = '';
    newChoice.value.isNone = false;
    alert.value = null;
}

function addChoice(): void {
    const payload = {
        name: newChoice.value.name,
        isNone: newChoice.value.isNone,
    };

    axios.post(`/questions/${props.question.id}/choices`, payload)
        .then(({ data }) => {
            emit('created', {
                ...payload,
                id: data.id,
            });

            alert.value = {
                status: 'success',
                summary: 'Le choix a été ajouté avec succès',
            };
        })
        .catch(({ response }) => {
            alert.value = {
                status: (409 === response.status) ? 'conflict' : 'error',
                detail: (409 === response.status) ? response.data['hydra:description'] : undefined
            };
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(addChoice, ["prevent"])
  }, [
    _createVNode(ChoiceAddButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
    }),
    _createVNode(ActionDialog, {
      visible: isOpen.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((isOpen).value = $event)),
      header: "Ajouter un choix",
      alert: _unref(alert),
      "campaign-id": props.campaignId,
      onHide: reset
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(Button), {
          label: "Annuler",
          class: "p-button-text",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (isOpen.value = false))
        }),
        _createVNode(_unref(Button), {
          type: "submit",
          label: "Ajouter",
          disabled: _unref(isDisabled) || _unref(isDuplicate)
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(InputText), {
            id: "new-choice-label",
            modelValue: newChoice.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newChoice.value.name) = $event)),
            class: _normalizeClass(["form-control", _unref(isDuplicate) && 'p-invalid is-invalid']),
            autocomplete: "off",
            required: ""
          }, null, 8, ["modelValue", "class"]),
          (_unref(isDuplicate))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Doublon"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("fieldset", null, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(FormCheck, {
                modelValue: newChoice.value.isNone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newChoice.value.isNone) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "alert", "campaign-id"])
  ], 40, _hoisted_1))
}
}

})